// AROMA COMPASS — Sinergie ufficiali (IT + EN), matrice di compatibilità
// olfattiva e sostituzioni autorizzate. In modalità EN, name/interpretation/ritual/intention
// usano le varianti *_en e i nomi inglesi degli oli (vedi oils.js).

export const DEFINED_SYNERGIES = [
  {
    pair: ["limone", "basilico"],
    name: "ATTIVO LA DIREZIONE",
    name_en: "I ACTIVATE MY DIRECTION",
    intention: "Attivo ciò che è pronto a muoversi e scelgo la mia direzione.",
    intention_en: "I activate what is ready to move and I choose my direction.",
    ritual:
      "Porta la sinergia vicino a te. Fai tre respiri lenti e ampi, poi immagina la prossima piccola mossa concreta della tua giornata.",
    ritual_en:
      "Hold the blend close. Take three slow, deep breaths, then imagine the next small concrete move of your day.",
    interpretation:
      "Oggi qualcosa dentro di te chiede movimento. Non un salto, ma un passo scelto. Limone accende ciò che era sospeso, Basilico gli dà una direzione riconoscibile: insieme trasformano l'esitazione in inizio.",
    interpretation_en:
      "Today something inside you is asking for movement. Not a leap, but a chosen step. Lemon kindles what had been on hold, Basil gives it a clear direction: together they turn hesitation into a beginning.",
  },
  {
    pair: ["pompelmo", "basilico"],
    name: "SBLOCCO LA DIREZIONE",
    name_en: "I UNBLOCK MY DIRECTION",
    intention: "Lascio andare ciò che frena e scelgo dove voglio andare.",
    intention_en: "I let go of what holds me back and I choose where I want to go.",
    ritual:
      "Avvicina la sinergia, inspira lentamente tre volte e nomina, anche solo dentro di te, ciò che stai lasciando andare.",
    ritual_en:
      "Bring the blend close, inhale slowly three times and name — even just inside yourself — what you are letting go.",
    interpretation:
      "Qualcosa si è fermato, ma non è chiuso: chiede solo di essere sciolto. Pompelmo apre e alleggerisce ciò che era compresso, Basilico ridà nitidezza alla tua direzione.",
    interpretation_en:
      "Something has stopped, but it isn't closed: it only asks to be loosened. Grapefruit opens and lightens what had become compressed, Basil brings clarity back to your direction.",
  },
  {
    pair: ["arancio_dolce", "abete"],
    name: "IL RISVEGLIO DELL'ENERGIA",
    name_en: "THE AWAKENING OF ENERGY",
    intention: "Mi risveglio a me stessa, con calma e con luce.",
    intention_en: "I awaken to myself, calmly and with light.",
    ritual:
      "Tieni la sinergia tra le mani, fai tre respiri lunghi e lascia che il profumo ti raggiunga come una prima luce del mattino.",
    ritual_en:
      "Hold the blend in your hands, take three long breaths, and let the scent reach you like the first morning light.",
    interpretation:
      "C'è un'energia nuova pronta a emergere, ma vuole essere accolta con dolcezza. Arancio dolce illumina i sensi, Abete radica: insieme aprono un risveglio pieno, non forzato.",
    interpretation_en:
      "A new energy is ready to emerge, but it wants to be welcomed with gentleness. Sweet Orange lights up the senses, Fir grounds: together they open a full, unforced awakening.",
  },
  {
    pair: ["limone", "abete"],
    name: "ATTIVO L'ENERGIA",
    name_en: "I ACTIVATE MY ENERGY",
    intention: "Attivo la mia energia e la lascio scorrere dove serve.",
    intention_en: "I activate my energy and let it flow where it is needed.",
    ritual:
      "Porta la sinergia al respiro. Tre inspirazioni consapevoli, e senti dove nel corpo qualcosa si accende.",
    ritual_en:
      "Bring the blend to your breath. Three conscious inhales, and feel where something lights up in your body.",
    interpretation:
      "La vitalità è già dentro di te, chiede solo di essere richiamata. Limone accende, Abete sostiene: insieme risvegliano un'energia limpida, pulita, disponibile.",
    interpretation_en:
      "Your vitality is already within you; it only asks to be called back. Lemon sparks, Fir sustains: together they awaken a clear, clean, available energy.",
  },
  {
    pair: ["eucalipto", "basilico"],
    name: "CREO SPAZIO E RITROVO LA DIREZIONE",
    name_en: "I MAKE SPACE AND FIND MY DIRECTION",
    intention: "Creo spazio dentro di me e lascio che la mia direzione torni chiara.",
    intention_en: "I create space within me and let my direction return clear.",
    ritual:
      "Avvicina la sinergia, chiudi gli occhi e fai tre respiri lenti immaginando che ogni espirazione allarghi lo spazio dentro di te. Quando ti senti più aperta, chiediti dove vuoi andare.",
    ritual_en:
      "Bring the blend close, close your eyes and take three slow breaths, imagining each exhale widens the space within you. When you feel more open, ask yourself where you want to go.",
    interpretation:
      "Quando la mente si affolla di pensieri, preoccupazioni o agitazione, la direzione si offusca. In Aroma Compass il «Freddo» dell'Eucalipto non è temperatura, ma la freschezza simbolica che raffredda ciò che è diventato troppo intenso e apre spazio mentale. In quello spazio, la nitidezza di Basilico può tornare a farsi sentire. Prima fai spazio. Poi ritrova la direzione.",
    interpretation_en:
      "When the mind becomes crowded with thoughts, worries or agitation, direction grows dim. In Aroma Compass, the «Cold» of Eucalyptus is not temperature but a symbolic freshness that cools what has become too intense and opens mental space. In that space, the clarity of Basil can be felt again. First make space. Then find your direction.",
  },
  {
    pair: ["basilico", "geranio"],
    name: "ARMONIZZO LA MIA DIREZIONE",
    name_en: "I HARMONIZE MY DIRECTION",
    intention: "Armonizzo ciò che sento e scelgo la mia direzione con centro e chiarezza.",
    intention_en: "I harmonize what I feel and choose my direction from center and clarity.",
    ritual:
      "Porta la sinergia vicino a te. Fai tre respiri lenti e ampi, e lascia che l'aroma ricomponga ciò che si muove dentro di te prima di scegliere il prossimo passo.",
    ritual_en:
      "Bring the blend close. Take three slow, deep breaths, and let the aroma recompose what is moving inside you before you choose your next step.",
    interpretation:
      "C'è una direzione che senti, ma qualcosa dentro chiede prima di essere ricomposto. Geranio armonizza ciò che si muove sul piano emozionale, ricompone polarità diverse e ti riporta al centro; Basilico dà forma alla tua direzione. Insieme lasciano che il tuo passo nasca da un equilibrio più stabile.",
    interpretation_en:
      "There is a direction you can sense, but something inside asks first to be recomposed. Geranium harmonizes what is moving on the emotional plane, reconciles opposing poles and brings you back to center; Basil gives shape to your direction. Together they let your step be born from a more stable balance.",
  },
  {
    pair: ["patchouli", "arancio_dolce"],
    name: "RIORDINO E MI RISVEGLIO",
    name_en: "I REORDER AND AWAKEN",
    intention: "Riordino ciò che era in fermento e mi apro con luce a ciò che sta arrivando.",
    intention_en: "I bring order back to what was in turmoil and open with light to what is arriving.",
    ritual:
      "Porta la sinergia vicino a te. Fai tre respiri lenti immaginando di ricomporre, un elemento alla volta, ciò che era disperso.",
    ritual_en:
      "Bring the blend close. Take three slow breaths and imagine recomposing, one element at a time, what had scattered.",
    interpretation:
      "Qualcosa dentro chiede di essere riorganizzato, e allo stesso tempo ha bisogno di luce per farlo. Patchouli riporta ordine in ciò che era in fermento, Arancio dolce accende una nota di calore e apertura: insieme trasformano la dispersione in un risveglio più stabile.",
    interpretation_en:
      "Something inside is asking to be reorganized and, at the same time, needs light to do so. Patchouli brings order back to what was in turmoil, Sweet Orange lights a note of warmth and openness: together they turn scattering into a steadier awakening.",
  },
  {
    pair: ["patchouli", "mandarino"],
    name: "RIORDINO NELL'ABBRACCIO",
    name_en: "I REORDER IN THE EMBRACE",
    intention: "Mi lascio abbracciare e da lì riordino ciò che è in fermento.",
    intention_en: "I let myself be embraced and from there I bring order to what is in turmoil.",
    ritual:
      "Avvicina la sinergia, appoggia una mano sul petto e fai tre respiri lenti. Lascia che l'abbraccio venga prima del riordino.",
    ritual_en:
      "Bring the blend close, place a hand on your chest and take three slow breaths. Let the embrace come before the ordering.",
    interpretation:
      "C'è agitazione dentro di te, ma prima di riorganizzare hai bisogno di sentirti accolta. Mandarino ti circonda di dolcezza, Patchouli riporta ordine in ciò che si era disperso: insieme trasformano il fermento in un ritorno a casa.",
    interpretation_en:
      "There is agitation inside you, but before you reorganize, you need to feel welcomed. Mandarin wraps you in softness, Patchouli brings order back to what had scattered: together they turn turmoil into a return home.",
  },
  {
    pair: ["patchouli", "lavanda"],
    name: "RIORDINO E MI LASCIO SOSTENERE",
    name_en: "I REORDER AND LET MYSELF BE HELD",
    intention: "Mi lascio sostenere e riordino ciò che ha bisogno di trovare posto.",
    intention_en: "I let myself be supported and reorder what needs to find its place.",
    ritual:
      "Porta la sinergia al respiro. Tre inspirazioni ampie e senti come, un poco alla volta, qualcosa dentro trova il suo posto.",
    ritual_en:
      "Bring the blend to your breath. Three deep inhales, and feel how, little by little, something inside finds its place.",
    interpretation:
      "Il fermento chiede di essere ricomposto, ma non da sola. Lavanda offre un sostegno silenzioso, Patchouli riporta ordine in ciò che era diventato caotico: insieme trasformano la fatica in una base più stabile.",
    interpretation_en:
      "The turmoil asks to be recomposed, but not on your own. True Lavender offers quiet support, Patchouli brings order back to what had become chaotic: together they turn fatigue into a steadier base.",
  },
  {
    pair: ["lavanda", "ylang_ylang"],
    name: "MI LASCIO ANDARE ALLA SERENITÀ",
    name_en: "I SURRENDER TO SERENITY",
    intention: "Mi lascio andare e accolgo la serenità che sta arrivando.",
    intention_en: "I let go and welcome the serenity that is arriving.",
    ritual:
      "Tieni la sinergia tra le mani, chiudi gli occhi e fai tre respiri lenti, lasciando che ogni espirazione porti via un poco di peso.",
    ritual_en:
      "Hold the blend in your hands, close your eyes and take three slow breaths, letting each exhale carry away a little weight.",
    interpretation:
      "Oggi il bisogno è di lasciarsi andare, di respirare più piano. Lavanda accompagna con dolcezza, Ylang Ylang apre allo spazio della serenità: insieme sciolgono la tensione in una qualità morbida, più leggera.",
    interpretation_en:
      "Today the need is to let go, to breathe more slowly. True Lavender accompanies you with gentleness, Ylang Ylang opens the space of serenity: together they dissolve tension into a softer, lighter quality.",
  },
  {
    pair: ["lavanda", "arancio_dolce"],
    name: "MI SOSTENGO E RISVEGLIO LA GIOIA",
    name_en: "I HOLD MYSELF AND AWAKEN JOY",
    intention: "Mi lascio sostenere e apro spazio alla gioia.",
    intention_en: "I let myself be supported and make room for joy.",
    ritual:
      "Avvicina la sinergia, fai tre respiri lenti e nota dove, dentro di te, qualcosa si scalda un poco.",
    ritual_en:
      "Bring the blend close, take three slow breaths and notice where, inside, something warms a little.",
    interpretation:
      "Hai bisogno di sostegno, ma anche di un piccolo raggio di luce. Lavanda offre la sua qualità gentile, Arancio dolce accende una nota di gioia e abbondanza: insieme rendono più leggero ciò che era diventato faticoso.",
    interpretation_en:
      "You need support, but also a small ray of light. True Lavender offers its gentle quality, Sweet Orange lights a note of joy and abundance: together they lighten what had become heavy.",
  },
  {
    pair: ["lavanda", "geranio"],
    name: "MI ARMONIZZO NEL SOSTEGNO",
    name_en: "I HARMONIZE WITHIN SUPPORT",
    intention: "Mi lascio sostenere e ritrovo il mio centro.",
    intention_en: "I let myself be supported and find my center again.",
    ritual:
      "Porta la sinergia vicino al petto, fai tre respiri lenti e lascia che l'aroma ricomponga ciò che aveva bisogno di essere ascoltato.",
    ritual_en:
      "Bring the blend close to your chest, take three slow breaths and let the aroma recompose what needed to be heard.",
    interpretation:
      "Qualcosa dentro chiede di essere ricomposto, ma con delicatezza. Lavanda accompagna con dolcezza, Geranio armonizza ciò che si muove sul piano emozionale: insieme ti riportano al centro senza forzature.",
    interpretation_en:
      "Something inside asks to be recomposed, but gently. True Lavender accompanies with softness, Geranium harmonizes what is moving on the emotional plane: together they bring you back to center without forcing.",
  },
  {
    pair: ["lavanda", "basilico"],
    name: "MI SOSTENGO E SCELGO LA DIREZIONE",
    name_en: "I HOLD MYSELF AND CHOOSE MY DIRECTION",
    intention: "Mi lascio sostenere e scelgo la mia direzione con fiducia.",
    intention_en: "I let myself be supported and choose my direction with trust.",
    ritual:
      "Avvicina la sinergia, fai tre respiri ampi e chiediti quale piccolo passo puoi fare oggi con dolcezza.",
    ritual_en:
      "Bring the blend close, take three deep breaths and ask yourself what small step you can take today with softness.",
    interpretation:
      "Prima di scegliere, hai bisogno di sentirti accompagnata. Lavanda offre il suo sostegno silenzioso, Basilico dà forma alla direzione: insieme lasciano che il tuo passo nasca da un posto più sicuro.",
    interpretation_en:
      "Before you choose, you need to feel accompanied. True Lavender offers its quiet support, Basil shapes the direction: together they let your step be born from a safer place.",
  },
  {
    pair: ["lavanda", "cisto"],
    name: "MI SOSTENGO E RICOMINCIO",
    name_en: "I HOLD MYSELF AND BEGIN AGAIN",
    intention: "Mi lascio sostenere e ricomincio con fiducia.",
    intention_en: "I let myself be supported and begin again with trust.",
    ritual:
      "Tieni la sinergia tra le mani, fai tre respiri lenti e immagina il primo, piccolo, gesto della tua ripartenza.",
    ritual_en:
      "Hold the blend in your hands, take three slow breaths and imagine the first small gesture of your fresh start.",
    interpretation:
      "Qualcosa sta per iniziare di nuovo e chiede di essere accolto con dolcezza. Lavanda offre sostegno, Cisto porta il segno di un nuovo inizio: insieme rendono la ripartenza più morbida.",
    interpretation_en:
      "Something is beginning again and asks to be welcomed with softness. True Lavender offers support, Cistus carries the sign of a new beginning: together they make the restart gentler.",
  },
  {
    pair: ["rosmarino", "basilico"],
    name: "CONSOLIDO LA MIA DIREZIONE",
    name_en: "I CONSOLIDATE MY DIRECTION",
    intention: "Consolido dentro di me la direzione che ho scelto.",
    intention_en: "I consolidate within me the direction I have chosen.",
    ritual:
      "Porta la sinergia al respiro. Tre inspirazioni consapevoli e ripetiti, mentalmente, la direzione che vuoi tenere.",
    ritual_en:
      "Bring the blend to your breath. Three conscious inhales, and silently repeat the direction you want to keep.",
    interpretation:
      "C'è una direzione che hai già intuito, ma ora chiede di essere trattenuta e resa stabile. Rosmarino aiuta a fissare ciò che stai acquisendo, Basilico dà nitidezza al passo che vuoi fare: insieme trasformano l'intuizione in una scelta che dura.",
    interpretation_en:
      "There is a direction you have already sensed, but now it asks to be held and made stable. Rosemary helps to fix what you are acquiring, Basil brings clarity to the step you want to take: together they turn intuition into a lasting choice.",
  },
  {
    pair: ["rosmarino", "limone"],
    name: "ATTIVO LA MEMORIA",
    name_en: "I ACTIVATE MEMORY",
    intention: "Attivo la mia attenzione e trattengo ciò che imparo.",
    intention_en: "I activate my attention and hold what I learn.",
    ritual:
      "Avvicina la sinergia, fai tre respiri lenti e porta lo sguardo, mentalmente, su ciò che oggi vuoi trattenere.",
    ritual_en:
      "Bring the blend close, take three slow breaths and mentally turn your gaze toward what you want to retain today.",
    interpretation:
      "La mente ha bisogno di svegliarsi con lucidità e di trattenere ciò che sta apprendendo. Limone accende l'attenzione, Rosmarino aiuta a fissare e organizzare: insieme sostengono studio, concentrazione e assimilazione.",
    interpretation_en:
      "The mind needs to wake with clarity and to retain what it is learning. Lemon lights up attention, Rosemary helps to fix and organize: together they support study, concentration and assimilation.",
  },
  {
    pair: ["rosmarino", "lavanda"],
    name: "CONSOLIDO CON DOLCEZZA",
    name_en: "I CONSOLIDATE GENTLY",
    intention: "Consolido ciò che ho appreso lasciandomi sostenere.",
    intention_en: "I consolidate what I have learned by letting myself be supported.",
    ritual:
      "Porta la sinergia vicino a te. Tre respiri lenti, e chiediti cosa, oggi, vuoi trattenere con dolcezza.",
    ritual_en:
      "Bring the blend close. Three slow breaths, and ask yourself what, today, you want to retain gently.",
    interpretation:
      "Stai integrando qualcosa di importante, ma serve anche gentilezza nel processo. Lavanda accompagna senza pressione, Rosmarino aiuta a fissare e rendere stabile ciò che è stato appreso: insieme trasformano la fatica dell'apprendere in un sedimento più morbido.",
    interpretation_en:
      "You are integrating something important, and the process also calls for gentleness. True Lavender accompanies without pressure, Rosemary helps to fix and stabilize what has been learned: together they turn the effort of learning into a softer sediment.",
  },
  {
    pair: ["rosmarino", "arancio_dolce"],
    name: "RISVEGLIO LA MEMORIA",
    name_en: "I AWAKEN MEMORY",
    intention: "Risveglio la mia attenzione e trattengo con leggerezza.",
    intention_en: "I awaken my attention and hold with lightness.",
    ritual:
      "Tieni la sinergia tra le mani, fai tre respiri lenti e nota come l'attenzione si accende in modo più leggero.",
    ritual_en:
      "Hold the blend in your hands, take three slow breaths and notice how attention lights up more lightly.",
    interpretation:
      "C'è un'attenzione che chiede di essere accesa, ma anche di essere alleggerita. Arancio dolce porta una nota di calore e apertura, Rosmarino sostiene concentrazione e memoria: insieme rendono lo studio e l'apprendimento meno pesanti.",
    interpretation_en:
      "There is an attention asking to be sparked, but also to be lightened. Sweet Orange brings a note of warmth and openness, Rosemary supports concentration and memory: together they make study and learning less heavy.",
  },
  {
    pair: ["rosmarino", "cisto"],
    name: "CONSOLIDO UN NUOVO INIZIO",
    name_en: "I CONSOLIDATE A NEW BEGINNING",
    intention: "Consolido dentro di me ciò che sta iniziando.",
    intention_en: "I consolidate within me what is beginning.",
    ritual:
      "Avvicina la sinergia, fai tre respiri lenti e nomina, dentro di te, ciò che stai imparando in questo momento nuovo.",
    ritual_en:
      "Bring the blend close, take three slow breaths and name, within yourself, what you are learning in this new moment.",
    interpretation:
      "Qualcosa di nuovo sta prendendo forma dentro di te e chiede di essere reso stabile. Cisto porta il segno di un nuovo inizio, Rosmarino aiuta a fissare ciò che stai acquisendo: insieme trasformano un passaggio in una base più solida.",
    interpretation_en:
      "Something new is taking shape inside you and asks to be made stable. Cistus carries the sign of a new beginning, Rosemary helps to fix what you are acquiring: together they turn a passage into a sturdier base.",
  },
  {
    pair: ["rosmarino", "geranio"],
    name: "CONSOLIDO IN EQUILIBRIO",
    name_en: "I CONSOLIDATE IN BALANCE",
    intention: "Consolido ciò che imparo restando nel mio centro.",
    intention_en: "I consolidate what I learn while staying in my center.",
    ritual:
      "Porta la sinergia vicino al petto, fai tre respiri lenti e senti come, dentro, qualcosa trova posto in modo armonico.",
    ritual_en:
      "Bring the blend close to your chest, take three slow breaths and feel how, inside, something finds its place harmoniously.",
    interpretation:
      "Stai integrando qualcosa e insieme hai bisogno di riportare armonia. Geranio ricompone ciò che si muove sul piano emozionale, Rosmarino fissa e rende stabile ciò che è stato acquisito: insieme trasformano il processo in un sedimento più centrato.",
    interpretation_en:
      "You are integrating something and, at the same time, you need to restore harmony. Geranium recomposes what is moving on the emotional plane, Rosemary fixes and stabilizes what has been acquired: together they turn the process into a more centered sediment.",
  },
  {
    pair: ["arancio_dolce", "cisto"],
    name: "IL RISVEGLIO DI UN NUOVO INIZIO",
    name_en: "THE AWAKENING OF A NEW BEGINNING",
    intention: "Mi risveglio a ciò che sta iniziando, con luce e fiducia.",
    intention_en: "I awaken to what is beginning, with light and trust.",
    ritual:
      "Tieni la sinergia tra le mani, fai tre respiri lenti e immagina la luce che accompagna il primo passo di ciò che sta iniziando.",
    ritual_en:
      "Hold the blend in your hands, take three slow breaths and picture the light that accompanies the first step of what is beginning.",
    interpretation:
      "C'è un nuovo inizio che vuole essere accolto con luce e apertura. Cisto porta il segno di ciò che sta ricominciando, Arancio dolce accende una nota di gioia e abbondanza: insieme rendono la ripartenza più luminosa, meno faticosa, più simile a un vero risveglio.",
    interpretation_en:
      "There is a new beginning that wants to be welcomed with light and openness. Cistus carries the sign of what is starting again, Sweet Orange lights a note of joy and abundance: together they make the restart brighter, less heavy, closer to a true awakening.",
  },
  {
    pair: ["litsea", "camomilla"],
    name: "TRANQUILLITÀ E SLOW MIND",
    name_en: "TRANQUILITY AND SLOW MIND",
    intention: "Rallento e mi godo il passo di questo momento.",
    intention_en: "I slow down and enjoy the pace of this moment.",
    ritual:
      "Tieni la sinergia tra le mani, chiudi gli occhi e fai tre respiri lenti. Poi, per qualche minuto, osserva ciò che accade dentro di te senza volerlo cambiare.",
    ritual_en:
      "Hold the blend in your hands, close your eyes and take three slow breaths. Then, for a few minutes, watch what happens inside you without wanting to change it.",
    interpretation:
      "Oggi il bisogno è rallentare, stare nel passo senza pretendere di arrivare. Litsea porta una tranquillità luminosa, Camomilla romana invita a una «slow mind»: non insegue obiettivi, insegna a godersi il momento un respiro alla volta. Non si tratta di raggiungere: si tratta di abitare il percorso.",
    interpretation_en:
      "Today the need is to slow down, to stay in each step without demanding to arrive. Litsea brings a luminous tranquility, Roman Chamomile invites a «slow mind»: it doesn't chase goals, it teaches you to enjoy the moment one breath at a time. It isn't about arriving: it's about inhabiting the journey.",
  },
  {
    pair: ["camomilla", "magnolia"],
    name: "COMPRENDO NEL MIO TEMPO",
    name_en: "I UNDERSTAND IN MY OWN TIME",
    intention: "Rallento, comprendo, e da lì trovo il mio passo.",
    intention_en: "I slow down, I understand, and from there I find my step.",
    ritual:
      "Tieni la sinergia tra le mani, fai tre respiri lenti e lascia che ciò che stai vivendo prenda il suo tempo per rivelare il suo senso.",
    ritual_en:
      "Hold the blend in your hands, take three slow breaths and let what you are living take its time to reveal its meaning.",
    interpretation:
      "Oggi non serve capire in fretta. Camomilla romana invita a una «slow mind», a stare nel momento un passo alla volta; Magnolia porta la qualità del significato, di ciò che chiede di essere compreso davvero. Insieme raccontano che, quando prendiamo le cose con calma e le comprendiamo, sappiamo anche dove andare.",
    interpretation_en:
      "Today there is no need to understand quickly. Roman Chamomile invites a «slow mind», to stay in the moment one step at a time; Magnolia carries the quality of meaning, of what asks to be truly understood. Together they say that, when we take things slowly and understand them, we also know where to go.",
  },
];

// -----------------------------------------------------------------------------
// MATRICE DI COMPATIBILITÀ OLFATTIVA
// -----------------------------------------------------------------------------
export const COMPATIBILITY = {
  COMPATIBLE: [
    ["basilico", "geranio"],
    ["patchouli", "arancio_dolce"],
    ["patchouli", "mandarino"],
    ["patchouli", "lavanda"],
    ["lavanda", "ylang_ylang"],
    ["lavanda", "arancio_dolce"],
    ["lavanda", "geranio"],
    ["lavanda", "basilico"],
    ["lavanda", "cisto"],
    ["rosmarino", "basilico"],
    ["rosmarino", "limone"],
    ["rosmarino", "lavanda"],
    ["rosmarino", "arancio_dolce"],
    ["rosmarino", "cisto"],
    ["rosmarino", "geranio"],
    ["arancio_dolce", "cisto"],
    ["litsea", "camomilla"],
    ["camomilla", "magnolia"],
  ],
  NOT_COMPATIBLE: [
    ["mirra", "basilico"],
    ["basilico", "patchouli"],
    ["lavanda", "limone"],
    ["rosmarino", "patchouli"],
    ["camomilla", "eucalipto"],
    ["camomilla", "basilico"],
    ["camomilla", "rosmarino"],
  ],
};

// -----------------------------------------------------------------------------
// SOSTITUZIONI AUTORIZZATE
// -----------------------------------------------------------------------------
export const PAIR_SUBSTITUTIONS = [
  { when: ["basilico", "patchouli"], use: ["basilico", "geranio"] },
  { when: ["camomilla", "basilico"], use: ["camomilla", "magnolia"] },
];

// -----------------------------------------------------------------------------
// HELPERS
// -----------------------------------------------------------------------------
export function samePair(a, b) {
  const [a1, a2] = a;
  const [b1, b2] = b;
  return (a1 === b1 && a2 === b2) || (a1 === b2 && a2 === b1);
}

export function findDefinedSynergy(oilId1, oilId2) {
  return (
    DEFINED_SYNERGIES.find((s) => samePair(s.pair, [oilId1, oilId2])) || null
  );
}

export function compatibilityStatus(oilId1, oilId2) {
  if (COMPATIBILITY.NOT_COMPATIBLE.some((p) => samePair(p, [oilId1, oilId2]))) {
    return "NOT_COMPATIBLE";
  }
  if (COMPATIBILITY.COMPATIBLE.some((p) => samePair(p, [oilId1, oilId2]))) {
    return "COMPATIBLE";
  }
  return "TO_VERIFY";
}

export function findSubstitution(oilId1, oilId2) {
  return (
    PAIR_SUBSTITUTIONS.find((s) => samePair(s.when, [oilId1, oilId2])) || null
  );
}

export function isExcluded(oilId1, oilId2) {
  return compatibilityStatus(oilId1, oilId2) === "NOT_COMPATIBLE";
}
